import mtg322 from "assets/shows/mtg322.jpg";
import mtg23 from "assets/about/give1.jpg";
import dixon from "assets/about/dixon.jpg";
import huh from "assets/about/huh.png";
import mtg25 from "assets/about/risk.jpg";
import bower from "assets/about/bower.jpg";

const mtg32Caption =
  "Mind The Gap XXXII, WATCHED: FOR YOUR VIEWING PLEASURE, 2024, Photo by Lynn Lane";

export const slides = [
  {
    image: mtg322,
    caption: mtg32Caption,
  },

  {
    image: huh,
    caption: mtg32Caption,
  },
  {
    image: dixon,
    caption: "WHITEWAVE SoloDuo Festival, 2025, Photo by Hisae Aihara",
  },
  {
    image: mtg25,
    caption: "Mind The Gap XXVII, The Risk, 2023, Photo by Lynn Lane",
  },
  {
    image: mtg23,
    caption: "Mind The Gap XXV, Giving While Needing, 2023, Photo by Lynn Lane",
  },
  {
    image: bower,
    caption:
      "A Gift From The Bower, In Communication With Vibration, 2023, Unknown",
  },
];

export const accomplishments = [
  "Houston MET Dance in partnership with Houston Endowment Dance Floor Grant Recipient, 2025",
  "City of Houston and Houston Arts Alliance 'Let Creativity Happen' Grant Recipient, 2025",
  "P.A.R.T.S Summer Residency - Thematic Lab with Stanley Ollivier on Energy & Care",
  "Association of Performing Arts Professionals Member",
  "City of Houston and Houston Arts Alliance 'Let Creativity Happen' Grant Recipient, 2024",
  "Houston MET Dance Floor Studio Residency, 2024",
  "Individual Foundations of Expressive Arts Therapy 1 & 2 from Center For Creative Arts Therapy",
  "Masters of Arts in Clinical Mental Health Counseling from Palo Alto University, 4.0 GPA, 2024",
  "Counseling Intern with Chill Counseling, Supervised by Cori Hill, LPC LMFT",
  "Training Acceptance for Somatic Experiencing® International 2023",
  "Dance Source Houston Member, 2022-Present",
  "ARCOS Dance Company Guest Artist Contract, 2016",
  "ARCOS Dance Intensive, 2016",
  "Hubbard Street Dance Chicago Summer Intensive, 2016",
  "Therapeutic Dance Movement Educator at The Monarch Institute, 2015",
  "Founding Member and Soloist for LÉON Contemporary Dance Company",
  "Hubbard Street Dance Chicago Winter Intensive, 2015",
  "Hubbard Street Dance Chicago Summer Intensive, 2015",
  "Apprentice with Revolve Dance Company, 2014",
];
